import React from 'react'
import { useSelector } from 'react-redux'
import { selectActiveSort } from '../../store/itinerary/itinerary.selectors'
import s from './Route.less'
import RouteMainInformationsTitle from './RouteMainInformationsTitle'
import RouteMainInformationsLabels from './RouteMainInformationsLabels'
import { PROVIDER_SHARED_BIKE, PROVIDER_TC, SORT_TYPES } from '../../store/itinerary/itinerary.constants'
import { buildCo2LeafsLabelComponents, LabelComponentBuilder } from '../../store/itinerary/routes.utils'
import { buildStepUpComponents } from '../genericComponents/StepUpNumber'
import TrainLowerPrice from './display/TrainLowerPrice'

export const getPositivePriceLabel = route => (route.price?.value > 0 ? route.price?.label : '')

export const getPriceLabel = route =>
  route.price.value > 0 || ![PROVIDER_SHARED_BIKE, PROVIDER_TC].includes(route.provider) ? route.price.label : '--'

const textComponents = text => [LabelComponentBuilder.text(text)]

export const useMainInformationsFields = route => {
  const activeSort = useSelector(selectActiveSort)
  switch (activeSort) {
    case SORT_TYPES.price:
      return {
        title: buildStepUpComponents(getPriceLabel(route)),
        labels: [route.duration].map(textComponents)
      }
    case SORT_TYPES.co2:
      return {
        title: buildStepUpComponents(route.co2Emissions),
        labels: [
          buildCo2LeafsLabelComponents(route.co2Score),
          ...[route.duration, getPositivePriceLabel(route)].map(textComponents)
        ]
      }
    case SORT_TYPES.duration:
      return {
        title: buildStepUpComponents(route.duration),
        labels: [getPositivePriceLabel(route)].map(textComponents)
      }
    default:
      if (route.main_information?.title && route.main_information?.labels) {
        return route.main_information
      }
      return {
        title: buildStepUpComponents(route.duration),
        labels: [getPositivePriceLabel(route)].map(textComponents)
      }
  }
}

const RouteMainInformations = ({ route, selected }) => {
  const infos = useMainInformationsFields(route)
  const labels = selected ? infos.labels : infos.labels.slice(0, 1)

  return (
    <div className={s.durationAndPrice}>
      <RouteMainInformationsTitle title={infos.title} isSelected={selected} />
      {route.isLowerPrice ? (
        <TrainLowerPrice price={route.price.label} />
      ) : (
        <RouteMainInformationsLabels labels={labels} />
      )}
    </div>
  )
}

export default RouteMainInformations
